import { render, staticRenderFns } from "./TypeDiscovery.vue?vue&type=template&id=e0e38ec8&"
import script from "./TypeDiscovery.vue?vue&type=script&lang=js&"
export * from "./TypeDiscovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports